/**
* @Author: zachalam
* @Date:   2017-01-19T13:38:09-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T16:13:02-08:00
*/



import {combineReducers} from 'redux';
import common from './common';
import auth from './auth';
import profile from './profile';
import extprofile from './extprofile';
import mail from './mail';
import trip from './trip';
import fav from './fav';
import settings from './settings';
import convo from './convo';
import blocked from './blocked';
import billing from './billing';
import search from './search';
import meta from './meta';
import gdpr from './gdpr';
import tos from './tos';
import privacy_policy from './privacy_policy';

const appReducer = combineReducers({
  common,
  auth,
  profile,
  extprofile,
  mail,
  trip,
  fav,
  settings,
  convo,
  blocked,
  billing,
  search,
  meta,
  gdpr,
  tos,
  privacy_policy
});

const rootReducer = (state, action) => {
  if(action.type === "CLEAR_EVERYTHING") {
    state = undefined
  }
  return appReducer(state,action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js